import Vue from 'vue'
import Router from 'vue-router'
import Home from './modules/home/Home'
import Layout from './modules/layout/Layout'

Vue.use(Router)

function lazyLoad(view) {
  return () => import(`@/modules/${view}.vue`)
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Layout,
      meta: {
        auth: ['user']
      },
      children: [
        {
          path: '/',
          component: Home,
          meta: {
            auth: ['user']
          }
        },
        {
          path: '/video-categories',
          name: 'video-categories',
          component: lazyLoad('videos/VideoCategories'),
          params: true,
          meta: {
            auth: ['user']
          }
        },
        {
          path: '/videos',
          name: 'videos',
          component: lazyLoad('videos/Videos'),
          params: true,
          meta: {
            auth: ['user']
          }
        },
        {
          path: '/video-page',
          name: 'video-page',
          component: lazyLoad('video-page/VideoPage'),
          params: true,
          meta: {
            auth: ['user']
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: lazyLoad('login/Login')
    }
  ]
})

// {
//   path: "/about",
//   name: "about",
//   // route level code-splitting
//   // this generates a separate chunk (about.[hash].js) for this route
//   // which is lazy-loaded when the route is visited.
//   component: () =>
//     import(/* webpackChunkName: "about" */ "./views/About.vue")
// }
